<div class="filter-item-container" fxLayout="column" fxLayoutAlign="start">
  <mat-checkbox
    [(ngModel)]="filterItem.isSelected"
    color="primary"
    (ngModelChange)="checkboxChanged()"
  >
    <div>
      {{ filterItem.filter.displayName }}
      @if (filterItem.group) {
        <span> ({{ filterItem.group }})</span>
      }
    </div>
  </mat-checkbox>
  @if (filterItem.isSelected) {
    <div class="filter-content" fxLayout="column">
      <div class="search-operator">
        <select
          [(ngModel)]="filterItem.filterOperator"
          (ngModelChange)="filterChanged()"
          aria-label="Select an operator"
        >
          @for (op of operators; track op) {
            <option [ngValue]="op">
              {{ op.displayName }}
            </option>
          }
        </select>
      </div>
      @if (
        filterItem.filterOperator &&
        filterItem.filterOperator.isSearchValueNeeded
      ) {
        <div class="search-value" fxFlex>
          @if (filterItem.uiType == uiType.Multiselect) {
            <multiselect
              [compactSize]="true"
              [items]="multiselectItems"
              [selectedItems]="selectedMultiselectItems"
              (selectionChanged)="multiselectSelectionChanged($event)"
              [placeholder]="'Select items...'"
            >
            </multiselect>
          }
          @if (filterItem.uiType == uiType.DropDown) {
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              fxFlex
              subscriptSizing="dynamic"
              class="dropdown-field extra-compact-field"
            >
              <mat-select
                [(ngModel)]="filterItem.searchValue"
                (selectionChange)="filterChanged()"
              >
                @for (value of filterItem.filter.values; track value) {
                  <mat-option [value]="value" aria-label="Select a value">{{
                    value
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (
            filterItem.uiType == uiType.Textbox ||
            filterItem.uiType == uiType.DatePicker
          ) {
            <div class="inputs">
              @if (filterItem.uiType == uiType.Textbox) {
                <mat-form-field
                  appearance="outline"
                  fxFlex
                  class="extra-compact-field"
                  subscriptSizing="dynamic"
                >
                  <input
                    matInput
                    [type]="inputType"
                    [(ngModel)]="filterItem.searchValue"
                    (change)="
                      filterItem.searchValue = filterItem.searchValue.trim()
                    "
                    (blur)="filterChanged()"
                    aria-label="Type a value"
                  />
                </mat-form-field>
              }
              @if (filterItem.uiType == uiType.DatePicker) {
                <mat-form-field appearance="outline" fxFlex>
                  <input
                    matInput
                    [matDatepicker]="datePicker"
                    [(ngModel)]="filterItem.searchValue"
                    (ngModelChange)="filterChanged()"
                    aria-label="Select a date"
                  />
                  <mat-datepicker-toggle matSuffix [for]="datePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #datePicker></mat-datepicker>
                </mat-form-field>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
